import { createApi } from "external/createApi";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"


const API_URL = process.env.REACT_APP_API_URL || "";

export const UserContext = React.createContext(null)

export const UserProvider = ( {children} ) => {

    const [user, setUser] = useState(null);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    
    const api = useMemo(() => {
        return createApi({
            baseUrl: API_URL,
            onUnauthorized: () => {
                setUser(null);
            }
        });
    }, []);

    useEffect(() => {
        setIsAuthenticating(true);
        api.me()
            .then(data => {
                    if(data.status === "USER_LOGGED_IN")
                    {   
                        setIsAuthenticating(false);
                        setUser({
                            username: data.username,
                            userFullName: data.userFullName
                        })
                        
                    }
                    else
                    {
                        setIsAuthenticating(false);
                        setUser(null);
                    }
                })
            .catch(() => {
                setIsAuthenticating(false);
                setUser(null)
            });
    }, [api]);

    const authenticateUser = useCallback(async (username, password) => {
        try
        {
            setIsAuthenticating(true);
            const data = await api.login({username, password});

            if (data.status === "USER_LOGGED_IN")
            {
                setUser({
                    username: data.username,
                    userFullName: data.userFullName
                });

                setIsAuthenticating(false);
                return true;
            }
            else
            {
                setUser(null);
                setIsAuthenticating(false);
                return false;
            }
        }
        catch (err)
        {
            setUser(null);
            setIsAuthenticating(false);
            return false;
        }
        
    }, [api]);

    const unauthenticateUser = () => {
        api.logout();
        setUser(null);
        setIsAuthenticating(false);
    };

    return (
        <UserContext.Provider value={{user, setUser, authenticateUser, unauthenticateUser, api, isAuthenticating}}>
            {children}
        </UserContext.Provider>
    );
}
 
export const useApi = () => useContext(UserContext);